// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"6ca548dc5214aae92a99","303":"39957e04a37f4f526f77","495":"179f63aa4d8c6dfa4d7e"}[chunkId] + ".js";
};